import { useQuery } from "@apollo/client";
import { GET_USERS } from "../gqls/user";

export default function useGetRefereeUsers() {
  const { data, loading } = useQuery(GET_USERS);
  const users = data?.users || [];

  let refereeUsers = users.filter(u => u.isReferrer && u.status.considerActive);

  return { loading, refereeUsers };
}
